<template>
  <div class="lab-staff">
    <StaffContents
    :profileImg="require('../../assets/img/lab/staff/04/profile.png')"
    :profileImgSp="require('../../assets/img/lab/staff/04/profile_sp.png')"
    profileAlt="04 MAKOTO IMAJI"
    answer01="専攻は有機金属化学。シアナミド架橋多核錯体の構築について研究していました。遷移金属は人と同じく、種類に応じて多様な特性を有しています。それらが集まったり組み合わさったりすることで、一つの金属だけでは発現できなかった特性を生み出すことが期待されます。私は架橋配位子としてシアナミドに着目し、様々な多核錯体の合成を検討しました。結果として種々の合成法を開発し、論文の投稿もできました。学生時代はとにかく研究が楽しくて、朝から晩までのめり込んでいましたね。"
    answer02="理由は3つあります。まず、コアとなる事業を複数有していること。これは会社の安定性にもつながるため、重要だと思いました。次に、社内論文審査制度。クレハには、社内で論文を執筆し発表する機会が与えられます。このような機会はモチベーションのひとつとして非常に魅力的に感じました。そして、技術立社として掲げている「ナケレバ、ツクレバ。」の精神に強く惹かれたためです。会社説明会でクレラップの開発エピソードを聞いた時は、社員の方々の研究への熱意に感銘を受けました。"
    answer03="リチウムイオン電池用負極材の開発および電池評価、コストダウンのための製造法開発業務などに携わったのち、新事業創出プロジェクトのメンバーに。5年後、10年後のクレハの中核を担う新ビジネスの創出を目指し、日々の業務に取り組んでいます。具体的には、将来必要となるモノやサービスを予測し、それをアイデアに落とし込んだ後、市場性・ビジネスモデル・競争優位性等を考慮してテーマを立案。テーマが採用されたら、研究開発本部との連携やオープンイノベーションを活用し、技術開発を進めていきます。"
    answer04="私が携わっているプロジェクトは、登山に例えるならまだ1合目。最終的には自分で考えて育てたものを製品化し、自分の手で売ることが目標です。そのためには、社内での議論やコミュニケーションはもちろん、社外でも活発にディスカッションし、多角的な情報を取り入れることが大切だと考えています。共同研究で他社の発表を聞くと、自社とは違った視点で考えていたり、スピード感が異なったりと、学ぶべきことが多くとても刺激的です。"
    answer05="「研究が好き」がモチベーションの根底にあること。皆さん、自分の好きなことが最終的に世のため人のためになると信じて、主体的に情熱を持って仕事に取り組んでいると思います。新しいものを生み出す過程では壁にぶつかることも多いですが、それでも妥協せずに突き詰める姿勢がクレハ全体にありますね。だからといってピリピリした雰囲気は一切なく、社風はとても和やかでアットホーム。オンオフのメリハリがあるからこそ、研究に没頭できる環境です。"
    answer06="休みの日は家の近くの公園を走るようにしています。研究所に在籍していた頃は、実験のための移動などで平日もある程度体を動かしていましたが、本社勤務だとデスクワークが中心になるため、運動不足になりがちなんですよね…。機会を見て「皇居ラン」にも一度挑戦してみたいなと思っています！家での過ごし方としては、新事業に携わる際に色々な知識が必要になるので、インプットの時間に当てています。会計、契約、貿易、品質管理などビジネスをする上で必要となる素養を身に着けたいと考えています。"
    :imageCut01="require('../../assets/img/lab/staff/04/image01.jpg')"
    :imageCut02="require('../../assets/img/lab/staff/04/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/lab/staff/04/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/lab/staff/04/image02_sp.jpg')"
    :schedule="require('../../assets/img/lab/staff/04/schedule.svg')"
    :scheduleSp="require('../../assets/img/lab/staff/04/schedule_sp.svg')"
    />
  </div>
</template>


<script>
import StaffContents from "@/components/lab/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents,
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
